import { Button, Card, Form, Input, Typography, message } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { getErrorMessage } from '../api/client';

export const LoginPage = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  if (user) return <Navigate to="/" replace />;
  const submit = async (values: { email: string; password: string }) => {
    try { await login(values.email, values.password); navigate('/'); }
    catch (error) { messageApi.error(getErrorMessage(error)); }
  };
  return (
    <div className="login-page">
      {contextHolder}
      <div className="login-story">
        <img className="login-logo" src="/assets/eagleeye-logo.png" alt="EagleEye Investigations" />
        <Typography.Paragraph>Every case. Every detail. Clearly tracked.</Typography.Paragraph>
        <div className="story-line" />
        <small>SECURE CASE MANAGEMENT</small>
      </div>
      <Card className="login-card" bordered={false}>
        <Typography.Title level={2}>Welcome back</Typography.Title>
        <Typography.Paragraph type="secondary">Sign in to your investigation workspace.</Typography.Paragraph>
        <Form layout="vertical" onFinish={submit} requiredMark={false} size="large">
          <Form.Item name="email" label="Email address" rules={[{ required: true }, { type: 'email' }]}>
            <Input prefix={<MailOutlined />} placeholder="you@company.com" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Enter your password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>Sign in</Button>
        </Form>
      </Card>
    </div>
  );
};
